/* eslint-ignore */
// @ts-nocheck
import React, { useCallback, useState } from 'react';

import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { IoAt } from 'react-icons/io5';
import { GiSmartphone } from 'react-icons/gi';
import { FaRegUser } from 'react-icons/fa';

import { toast } from 'react-toastify';
import { phoneMask } from '~/utils/functions';

import {
  Container,
  Title,
  Text,
  FormContainer,
  InputCond,
  InputDoc,
  WrapInputName,
  ButtonNext,
  ButtonBack,
  ButtonText,
  ButtonsWrap,
  Spinner,
} from './styles';
import { useFirstAccess } from '../../../../../hooks/useFirstAccess';
import { postContact } from '~/services/firstAccessServices';

function PersonalData({ activeStep, setActiveStep }) {
  const {
    document,
    codCond,
    email,
    handleSetEmail,
    name,
    handleSetName,
    lastName,
    handleSetLastName,
    phone,
    handleSetPhone,
    userId,
    siteId,
    handleSetContactId,
  } = useFirstAccess();

  const [emailError, setEmailError] = useState('');
  const [nameError, setNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleEmail = useCallback((event) => {
    let error = '';
    const emailValue = event.target.value;
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailValue)) {
      error = 'Endereço de e-mail inválido';
    }
    if (!emailValue) {
      error = 'Campo obrigatório';
    }
    handleSetEmail(emailValue);
    setEmailError(error);
  }, []);

  const handleNextStepClick = useCallback(async () => {
    let hasError = false;

    if (!name) {
      setNameError('Campo obrigatório');
      hasError = true;
    }

    if (!lastName) {
      setLastNameError('Campo obrigatório');
      hasError = true;
    }

    if (!email) {
      setEmailError('Campo obrigatório');
      hasError = true;
    }

    if (!phone) {
      setPhoneError('Campo obrigatório');
      hasError = true;
    }

    if (hasError) return;

    if (
      name &&
      lastName &&
      email &&
      phone &&
      !nameError &&
      !lastNameError &&
      !emailError &&
      !phoneError
    ) {
      try {
        setIsLoading(true);
        const contactIdResponseEmail = await postContact(
          email,
          'EMAIL',
          document,
          codCond,
          userId,
          siteId,
          name,
          lastName
        );
        handleSetContactId(contactIdResponseEmail);
        const contactIdResponsePhone = await postContact(
          phone.replace(/[^\d]/g, ''),
          'PHONE',
          document,
          codCond,
          userId,
          siteId,
          name,
          lastName
        );

        if (contactIdResponseEmail && contactIdResponsePhone) {
          setActiveStep(activeStep + 1);
        }
      } catch (error) {
        toast.error('Ocorreu um erro interno na aplicação');
      } finally {
        setIsLoading(false);
      }
    }
  }, [name, lastName, email, phone, document, codCond, userId, siteId]);

  const handlePhone = useCallback((event) => {
    setPhoneError('');
    handleSetPhone(event.target.value);
  }, []);

  const onBlur = () => {
    handleSetPhone(phoneMask(phone));
  };

  const onFocus = () => {
    handleSetPhone(phone.replace(/[^\d]/g, ''));
  };

  return (
    <Container>
      <Title>Dados cadastrais</Title>
      <Text>Informe os seus dados preenchendo os campos abaixo.</Text>
      <FormContainer>
        <WrapInputName>
          <InputCond
            className="name"
            labelText="Nome*"
            inputType="text"
            inputName="name"
            inputId="name"
            value={name}
            onChange={(e) => {
              setNameError('');
              handleSetName(e.target.value);
            }}
            icon={FaRegUser}
            msgError={nameError}
          />
          <InputCond
            className="lastName"
            labelText="Sobrenome*"
            inputType="text"
            inputName="lastName"
            inputId="lastName"
            value={lastName}
            onChange={(e) => {
              setLastNameError('');
              handleSetLastName(e.target.value);
            }}
            msgError={lastNameError}
          />
        </WrapInputName>
        <InputCond
          className="inputEmail"
          labelText="Email*"
          inputType="text"
          inputName="email"
          inputId="email"
          value={email}
          onChange={(e) => {
            setEmailError('');
            handleEmail(e);
          }}
          icon={IoAt}
          msgError={emailError}
        />
        <InputDoc
          className="celphone"
          labelText="Celular com DDD*"
          inputType="text"
          inputName="cel"
          inputId="cel"
          value={phone}
          onChange={(e) => handlePhone(e)}
          onBlur={() => onBlur()}
          onFocus={() => onFocus()}
          icon={GiSmartphone}
          msgError={phoneError}
          mask="(99) 99999-9999"
        />
        <ButtonsWrap>
          <ButtonNext
            buttonType="primary"
            iconRight={AiOutlineArrowRight}
            onClick={() => !isLoading && handleNextStepClick()}
            disabled={isLoading}
            isLoading={isLoading}
          >
            {isLoading ? <Spinner color="#fff" size={24} /> : 'Continuar'}
          </ButtonNext>
          <ButtonBack
            buttonType="outline"
            iconLeft={AiOutlineArrowLeft}
            onClick={() => setActiveStep(activeStep - 1)}
          >
            <ButtonText>Voltar</ButtonText>
          </ButtonBack>
        </ButtonsWrap>
      </FormContainer>
    </Container>
  );
}

export default PersonalData;
